<template>
  <v-container id="surveyContainer" grid-list-md text-xs-center>
    <div v-if="!!quiz" class="row">
      <div class="col-12">
        <p class="greeting" v-html="parsedGreeting()"/>
        <p class="advice" v-html="quiz.advice"/>

        <div class="hintBox">
          <div class="visiblePart">
            <p>Por que isso importa?</p>
            <img
              src="/static/hint_question.png"
              @mouseover="isMobileView ? '' : isHoveringHelp = true"
              @mouseleave="isMobileView ? '' : isHoveringHelp = false"
              @click="isHoveringHelp = true"
            >
          </div>

          <transition name="mobileTooltipTransition">
            <div v-show="isHoveringHelp" class="tooltip" @click="isHoveringHelp = false">
              <p>{{ quiz.hint }}</p>
            </div>
          </transition>
        </div>

        <v-form ref="form">
          <v-layout row wrap>
            <v-flex
              v-for="(question) in quiz.questions"
              :key="question.id"
              class="no-padding-mobile md6 xs12"
              :class="[question.style == 'full_width' ? 'md12' : 'md6']"
            >
              <question
                :question="question"
                @duplicatePreviousQuestion="$emit('duplicatePreviousQuestion', question)"
              ></question>
            </v-flex>
          </v-layout>
        </v-form>
      </div>
    </div>
  </v-container>
</template>

<script>
import Question from "./Question";
import * as exams from "../assets/survey.json";
import Vue from "vue";
import Vuelidate from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";

Vue.use(Vuelidate);

export default {
  name: "survey",
  components: {
    [Question.name]: Question
  },
  props: {
    quiz: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isMobileView: false,
      isHoveringHelp: false,
      userName: null,
      document: null
    };
  },
  methods: {
    canProceed() {
      return this.$refs.form.validate();
    },
    parsedGreeting() {
      return this.quiz.greeting.replace("@Nome", this.firstName);
    },
    getResult() {
      return this.quiz;
    },
    setExam(quiz) {
      quiz = JSON.parse(quiz);
      if (!!quiz) {
        this.result = "Erro ao montar questionário";
      }
      this.quiz = quiz;
    },
    updateMobileStatus() {
      this.isMobileView = window.matchMedia("(max-width: 991px)").matches;
    }
  },
  validations() {
    return {
      quiz: {
        questions: {
          $each: {
            answer: {
              requiredIf: requiredIf(question => {
                return (
                  this.dependencyValidation(question.filter) &&
                  this.genderValidation(question.filter) &&
                  question.type != "check_box"
                );
              })
            }
          }
        }
      }
    };
  },
  created() {
    this.updateMobileStatus();
    window.addEventListener("resize", this.updateMobileStatus);

    this.userName = sessionStorage.getItem("name");
    this.document = sessionStorage.getItem("document");

    if (this.userName == null || this.document == null) {
      this.$router.push("/");
    } else {
      this.firstName = this.userName.split(" ")[0];
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateMobileStatus);
  }
};
</script>
<style lang="scss">
#surveyContainer {
  padding-bottom: 80px;
}
.advice {
  margin-top: 20px;
  font-weight: 600;
  font-size: 14px;
  color: #034151;
  text-align: left;
}
.hintBox:hover .tooltip {
  opacity: 1;
}

.tooltip {
  transition: ease 0.3s opacity;
  padding: 13px 13px;
  border-radius: 5px;
  color: white;
  background-color: #00bfb3;
  position: relative;
  max-width: 50%;
  opacity: 1;
  width: 100%;
  z-index: 1;

  p {
    margin-bottom: 0px;
  }
}

.hintBox {
  .visiblePart {
    p {
      margin: auto 0;
    }
    img {
      height: 40px;
      width: 40px;
      margin: 5px 5px 5px 5px;
    }
    display: flex;
  }

  height: 50px;
  display: block;
  text-align: left;
  color: #00bfb3;
  margin-bottom: 15px;
}
.mobileTooltipTransition-enter-active,
.mobileTooltipTransition-leave-active {
  transition: opacity 0.5s;
}
.mobileTooltipTransition-enter,
.mobileTooltipTransition-leave-to {
  opacity: 0;
}
@media (max-width: 991px) {
  .no-padding-mobile {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .hintBox {
    .visiblePart {
      p {
        margin: auto 0;
      }
      img {
        height: 30px;
        width: 30px;
        margin: 0;
      }
      display: flex;
    }
    height: auto;
    font-size: 12px;
  }
  .container p.greeting {
    font-size: 30px;
    line-height: 30px;
  }
  .container p.subtitle {
    font-size: 20px;
    font-weight: 700;
  }
  .tooltip {
    p {
      margin: 0;
      margin-bottom: 0px;
      background-color: #eeeeee;
      border-radius: 5px 5px 0px 0px;
      padding: 20px 30px 30px 30px;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
    }
    background-color: #00000070;
    transition: ease 0.3s opacity;
    color: #053541;
    position: fixed;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    max-width: 100%;
    opacity: 1;
    width: 100%;
    z-index: 2;
  }
}

.container .greeting {
  color: #034151;
  font-size: 50px;
  font-family: Yanone Kaffeesatz;
  font-weight: 400;
  text-align: left;
  margin-bottom: 10px;
  overflow: hidden;
  line-height: 55px;
}

.container .subtitle {
  color: #05c1c8;
  font-size: 25px;
  font-weight: 700;
  margin: 5px 0;
}

.row .questions {
  text-align: left;
}
.row .questions h2 {
  font-size: 14px;
  line-height: 21px;
}

.form-group__message {
  color: #ff4c43;
  text-align: left;
  width: 100%;
  float: left;
  font-weight: 500;
}
select {
  display: block;
}
/*scrollbar*/
::-webkit-scrollbar-track {
  border-radius: 25px;
  background-color: #eeeeee;
}

::-webkit-scrollbar {
  width: 9px;
  background-color: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  border-radius: 25px;
  /* background-color: rgb(199, 199, 199); */
  background-color: rgba(189, 189, 189, 0.651);
}
</style>



// WEBPACK FOOTER //
// src/components/Survey.vue